/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { DOCUMENT, NgOptimizedImage } from '@angular/common'
import { UsuarioService } from 'src/app/services/usuario.service'
import { AccessibilityService } from 'src/app/services/accessibility.service'
import packageJson from '../../../../../package.json'
import { StorageService } from 'src/app/services/storage.service'
import { TranslateService, TranslatePipe } from '@ngx-translate/core'
import { RouterLink, RouterLinkActive } from '@angular/router'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, TranslatePipe, NgOptimizedImage],
})
export class HeaderComponent {
  usuarioService = inject(UsuarioService)
  a11y = inject(AccessibilityService)
  private translate = inject(TranslateService)
  private document = inject(DOCUMENT)
  private storage = inject(StorageService)

  readonly version = packageJson.version
  readonly selectedLanguage = signal(this.storage.getLanguage())

  setLanguage(lang: string): void {
    this.translate.use(lang)
    this.selectedLanguage.set(lang)
    this.storage.setLanguage(lang)
    this.document.documentElement.lang = lang
  }
}
